import classNames from 'classnames';
import React, { useId } from 'react';

export const sizes = {
  small: 'py-2.5 px-4 text-base md:text-sm',
  default: 'py-4 px-5',
  // 5a console control height (44px). An opt-in size rather than retargeting `default`,
  // so Auth/Settings keep their taller fields.
  console: 'h-11 px-3.5 text-base md:text-sm',
  empty: '',
};

/*
 * The one shared style constant in the codebase — imported by WizardStep1/PasswordInput to
 * style controls that aren't <Input>s. Keep it exported.
 * Deliberately no `w-full`: call sites pass their own width.
 */
/*
 * A disabled field states its own colours rather than fading the enabled ones: `opacity-75`
 * dimmed the VALUE along with the chrome, so a read-only account name (Settings shows one
 * for lapsed subscriptions) was harder to read than the placeholder next to it.
 */
export const inputClassNames = 'bg-ui-sunken text-ui border border-ui-hair-2 rounded-field placeholder:text-ui-4 transition-colors duration-150 focus:border-ui-accent focus:outline-none disabled:cursor-not-allowed disabled:border-ui-hair disabled:bg-ui-bg disabled:text-ui-3';
export const labelClassNames = 'mb-1.5 flex items-baseline justify-between text-sm text-ui';
export const hintClassNames = 'text-ui-3 font-normal';

export const Input = ({ className, size, label, hint, id, ...rest }) => {
  // `id = nanoid()` as a default param regenerated on every render, so htmlFor pointed at
  // a stale id. useId is stable across renders.
  const generatedId = useId();
  const inputId = id ?? generatedId;

  return (
    <>
      {label && (
        <div className={labelClassNames}>
          <label htmlFor={inputId}>{label}</label>
          {hint && <span className={hintClassNames}>{hint}</span>}
        </div>
      )}
      <input id={inputId} className={classNames(inputClassNames, sizes[size], className)} {...rest} />
    </>
  );
};

Input.defaultProps = {
  size: 'default',
};
